import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Flex,
} from '@chakra-ui/react';
import React from 'react';

const ErrorAlert = ({ error, title, message, children }: {
  error?: Error | null, title?: string, message?: React.ReactElement | string, children?: React.ReactNode
}) => {
  if (!error) return null;

  return (
    <Alert status="error">
      <Flex direction="column" gap="1em">
        <Flex>
          <AlertIcon />
          <AlertTitle>{title}</AlertTitle>
        </Flex>
        <AlertDescription>{children || message || error.message}</AlertDescription>
      </Flex>
    </Alert>
  );
};

export default ErrorAlert;
